import {type KilnCheckSheetHousekeepingSectionFormValues} from '../../../types'

export const housekeepingSectionDefaultValues: KilnCheckSheetHousekeepingSectionFormValues = {
  lancingFloorsTimeCleaned: '',
  lancingFloorsComment: '',
  coolerFloorTimeCleaned: '',
  coolerFloorTimeComment: '',
  burnerFloorTimeCleaned: '',
  burnerFloorTimeComment: '',
  shiftExpectationAreasTimeCleaned: '',
  shiftExpectationComment: '',
  coolerRoofAtHoodTimeCleaned: '',
  coolerRoofAtHoodComment: ''
}
